import React from 'react';
import styled, { css } from 'styled-components';
import classnames from 'classnames';
import { spinAnimation } from 'js/config/style';

const colored = css`
  color: ${({ color }) => color};
`;

const Icon = styled(({ spin, ...rest }) => <i {...rest} />)`
  ${({ spin }) => spin && spinAnimation}
  ${({ color }) => color && colored}
`;

export default ({ className, name, ...rest }) => (
  <Icon className={classnames(className, 'fa', `fa-${name}`)} {...rest} />
);
